import React, { useEffect, useState } from "react";
import ProductCardNew from "../../components/card/ProductCardNew";
import { Link } from "react-router-dom";
import productService from "../../services/productService";
import { useApiEnhanced } from "../../hooks/useApiEnhanced";
import "./NewArrivals.css";

export default function NewArrivals({ onProductClick }) {
  const [newArrivals, setNewArrivals] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch new arrival products using your API
  const { data: newProductsResponse, loading: productsLoading } =
    useApiEnhanced(
      () =>
        productService.getProducts({
          page: 1,
          limit: 8,
          isNew: "true",
          status: "Active",
        }),
      { immediate: true }
    );

  // Process new products when data is loaded
  useEffect(() => {
    if (newProductsResponse?.success && newProductsResponse?.data) {
      setNewArrivals(newProductsResponse.data);
      setLoading(false);
    }
  }, [newProductsResponse]);

  // Fallback: Set loading to false if API call completes
  useEffect(() => {
    if (!productsLoading) {
      setLoading(false);
    }
  }, [productsLoading]);

  return (
    <section className="product-section">
      <div className="container">
        <div className="section-header">
          <h2>New Arrivals</h2>
          <Link to="/products?filter=new" className="view-all">
            View all
          </Link>
        </div>

        {loading ? (
          <div className="product-grid">
            <div className="loading-spinner-container">
              <div className="loading-spinner"></div>
              <p className="loading-text">Loading new arrivals...</p>
            </div>
          </div>
        ) : newArrivals.length > 0 ? (
          <div className="product-grid">
            {newArrivals.map((product) => (
              <ProductCardNew
                key={product._id}
                product={product}
                onProductClick={onProductClick}
              />
            ))}
          </div>
        ) : (
          <div className="product-grid">
            <div className="no-products">
              <p>No new arrivals at the moment. Check back soon!</p>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
